/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Trip_Stat_LoadInputs */

const en_ui_trip_stat_load = /** @type {(inputs: Ui_Trip_Stat_LoadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Training Load`)
};

const de_ui_trip_stat_load = /** @type {(inputs: Ui_Trip_Stat_LoadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trainingslast`)
};

/**
* | output |
* | --- |
* | "Training Load" |
*
* @param {Ui_Trip_Stat_LoadInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_trip_stat_load = /** @type {((inputs?: Ui_Trip_Stat_LoadInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Trip_Stat_LoadInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_trip_stat_load(inputs)
	return de_ui_trip_stat_load(inputs)
});